"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderPopupImage = renderPopupImage;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const dialog_1 = require("../../../Partials/Components/ModalDialog/dialog");
const GalleryImageWrapper_1 = require("../../../Partials/Components/Gallery/components/GalleryImageWrapper");
const types_1 = require("../../../Partials/Components/ModalDialog/types");
const PopupImage = ({ mediaItem }) => {
    const [isPopupOpened, setIsPopupOpened] = React.useState(true);
    React.useEffect(() => {
        setIsPopupOpened(true);
    }, [mediaItem]);
    const closeDialogHandler = () => {
        setIsPopupOpened(false);
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(dialog_1.Dialog, { onClose: closeDialogHandler, title: "", isOpen: isPopupOpened, classes: "desktop-modal-gallery spot-media-popup", popupType: types_1.PopupType.SINGLE_MEDIA, children: (0, jsx_runtime_1.jsx)(GalleryImageWrapper_1.default, { mediaItem: mediaItem, isMainImage: true, itemKey: mediaItem.imageHeight, isInModal: true }) }) }));
};
exports.default = PopupImage;
function renderPopupImage(mediaItem, element) {
    (0, app_1.reactDOMRender)((0, jsx_runtime_1.jsx)(PopupImage, { mediaItem: mediaItem }), element);
}
